import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Station } from '../../../../shared/types';
import { useAdminStations } from '../../../hooks/useAdminStations';
import { AdminStationForm } from './StationForm';

export const AdminStationEdit = () => {
    const { id } = useParams<{ id: string }>();
    const [selectedStation, setSelectedStation] = useState<Station>();
    const { data: stations = [], isFetched } = useAdminStations();

    useEffect(() => {
        if (!isFetched) return;

        const station = stations.find((station) => station._id.toString() === id!);

        if (station) setSelectedStation(station);
    }, [id, isFetched]);

    if (!selectedStation) return null;

    return <AdminStationForm station={selectedStation} />;
};
